import React from 'react';
import { Link } from 'react-router-dom';
import Logo from 'assets/images/logo2.png';
import {useTranslation} from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className={"bg-custom-blue text-white"}>
      <div className="footer-top">
        <div className="container">
          <div className={"row gy-3 row-cols-1 row-cols-sm-2 row-cols-md-4 py-5"}>
            <div>
              <Link to="/">
                <img className={"mw-100"} src={Logo} alt="" width={150}/>
              </Link>
            </div>
            <div>
              <span className={"d-block text-uppercase mb-2 fw-600"}>{t("header.nav2")}</span>
              <ul>
                <li className={"mb-1"}><Link to={"/page/maqsad-va-vazifalar"} className={"text-white"} >{t("header.nav21")}</Link></li>
                <li className={"mb-1"}><Link to={"/staff"} className={"text-white"} >{t("header.nav3")}</Link></li>
                <li className={"mb-1"}><Link to={"/page/ustav"} className={"text-white"} >{t("header.nav4")}</Link></li>
                <li className={"mb-1"}><Link to={"/page/korxona-tuzilmasi"} className={"text-white"} >{t("header.nav5")}</Link></li>
              </ul>
            </div>
            <div>
              <span className={"d-block text-uppercase mb-2 fw-600"}>{t("header.nav6")}</span>
              <ul>
                <li className={"mb-1"}><Link to={"/page/biznes-reja"} className={"text-white"}>{t("header.nav20")}</Link></li>
                <li className={"mb-1"}><Link to={"/page/moliyaviy-iqtisodiy-korsatkichlar"} className={"text-white"}>{t("header.nav7")}</Link></li>
              </ul>
            </div>
            <div>
              <span className={"d-block text-uppercase mb-2 fw-600"}>{t("header.nav14")}</span>
              <ul>
                <li className={"mb-2"}>
                  Адрес: 100041, Тошкент, ул. Олимлар, 64
                </li>
                <li className={"mb-2"}>
                  Телефон: <br/>
                  <a className={"text-white"} href="tel:+998953409001"> (+998) 95 340-90-01</a>
                </li>
                <li className={"mb-2"}>
                  Email: <br/>
                  <a className={"text-white"} href="tel:+998953409001"> ggpuz@mail.ru</a>
                </li>
                <li className={"mb-1"}>
                  Факс: <br/>
                  -
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bottom py-2 border-top border-light-blue">
        <div className="container">
          <div className={"text-white"}>&copy; {(new Date()).getFullYear()}. {t("footer.right")} </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;